import styles from "./RoadAlerts.module.css";

import { MDSSContext } from "context/MDSSContext";
import { useContext, useEffect, useState } from "react";

const RoadAlerts = () => {
  const {
    showRoadCondition,
    showRoadAlert,
    handleShowRoadCondition,
    MDSSData,
  } = useContext(MDSSContext);

  const [conditionColor, setConditionColor] = useState("default");

  useEffect(() => {
    const DataKV = [];
    //seperate by route id
    MDSSData.forEach((data) => {
      if (data["route_id"] === "DONVKV") {
        DataKV.push(data);
      }
    });

    // console.log("from road alert 1", DataKV);

    if (DataKV.length !== 0) {
      console.log("from road alert 2", DataKV);
      const shownConditionColor = DataKV[0]["road_alert"].toUpperCase();
      setConditionColor(shownConditionColor);
    } else {
      setConditionColor("default");
    }
  }, [MDSSData]);

  return (
    <div>
      {showRoadAlert && (
        <div
          className={`${styles["road-alerts"]} ${styles[`${conditionColor}`]}`}
          onClick={() => {
            if (showRoadCondition) {
              handleShowRoadCondition(false);
            } else if (!showRoadCondition) {
              handleShowRoadCondition(true);
            }
          }}
        >
          <h5>ROAD ALERTS</h5>
          <div className={styles["road-alerts-ok"]}>OK</div>
          <div className={styles["road-alerts-marginal"]}>MARGINAL</div>
          <div className={styles["road-alerts-poor"]}>POOR</div>
          <div className={styles["road-alerts-extreme"]}>EXTREME</div>
        </div>
      )}
    </div>
  );
};

export default RoadAlerts;
